import axios from 'axios'
class DownloadSignaturesService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    /**
    * @author Gustavo Adolfo Pacheco Cruz
    * @description 
    * @memberof 
    */
    async getSignatures(token) {
        let response = await axios.post(`${this.apiUrl}/user-generate-keys-certificate`, {},
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
        return response.data.data
    }
    /**
    * @author Gustavo Adolfo Pacheco Cruz
    * @description 
    * @memberof 
    */
    async getCurrentSignatures(token) {
        let response = await axios.put(`${this.apiUrl}/user-generate-keys-certificate`, {},
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
        return response.data.data
    }

    async putUserKeys(token) {
        let response = await axios.put(`${this.apiUrl}/user-keys`, {},
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
        return response.data.data
    }

}

export { DownloadSignaturesService as default }